import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'

import { SharedUiPersonaAvatarModule } from '@se-po/shared-ui-persona-avatar'
import { SharedFeaturePersonaImageModalModule } from '../lib/shared-feature-persona-image-modal.module'
import { PersonaImageModalDocsComponent } from './persona-image-modal-docs/persona-image-modal-docs.component'
import { PersonaImageModalExampleComponent } from './persona-image-modal-docs/persona-image-modal-example.component'
import { SeFeImageUploaderModule } from 'se-fe-image-uploader'
import { environment } from '@se-po/shared-environments'
import { SeFePageModule } from 'se-fe-page'
import { SeFeHeaderModule } from 'se-fe-header'

@NgModule({
  declarations: [PersonaImageModalDocsComponent, PersonaImageModalExampleComponent],
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeaturePersonaImageModalModule,
    SharedUiPersonaAvatarModule
  ],
  exports: [PersonaImageModalDocsComponent],
})
export class SharedFeaturePersonaImageModalDocsModule {}
